import { PropsWithChildren } from 'react';

import classes from 'components/widgets/ChangeAnalysisTrackedActivities/tableLocalFilters/tableLocalFilters.module.scss';

export interface ITableLocalFiltersFields {
    status: ISelectOption<string>[];
    criticalPath?: boolean;
}

export const TableLocalFilters = ({ children }: PropsWithChildren) => {
    return <div className={classes.tableLocalFiltersContainer}>{children}</div>;
};
